<template>
  <modal @close="$emit('fechar')" class="modal-autorizar-pagamento">
    <form @submit.prevent="confirmar" class="formulario">
      <h3 class="titulo titulo_medio u-margem-inferior-media">
        Autorizar pagamento
      </h3>
      <hr class="u-margem-inferior-grande" />
      <div class="grade__linha">
        <div class="grade__coluna">
          <label class="label" for="ordemBancaria">Ordem bancária</label>
          <input
            type="text"
            v-model="ordemBancaria"
            name="ordemBancaria"
            id="ordemBancaria"
            class="numero-ordem-bancaria"
            placeholder="Ex: 2017OB000012"
            required
          />
        </div>
        <div class="grade__coluna">
          <label class="label" for="dataDoPagamento">Data do pagamento</label>
          <input
            type="text"
            v-model="dataDoPagamento"
            name="dataDoPagamento"
            id="dataDoPagamento"
            placeholder="Ex: 01/01/2017"
            v-mask="'99/99/9999'"
            required
          />
        </div>
      </div>
      <hr class="u-margem-superior-grande u-margem-inferior-media" />
      <div class="grade__linha_alinhar-horizontal-direita formulario-button">
        <button
          type="button"
          @click="$emit('fechar')"
          class="botao botao_cinza botao_medio u-margem-direita-pequena"
        >
          Voltar
        </button>
        <button
          type="submit"
          class="botao botao_cor-terciaria botao_medio"
          :class="{ 'is-loading': carregando }"
        >
          Confirmar pagamento
        </button>
      </div>
    </form>
  </modal>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Modal from "../../../shared/Modal";

export default {
  name: "modal-autorizar-pagamento",
  components: { Modal },
  directives: { mask: AwesomeMask },
  props: {
    carregando: { type: Boolean, default: false },
  },
  data() {
    return {
      ordemBancaria: "",
      dataDoPagamento: "",
    };
  },
  methods: {
    confirmar() {
      this.$emit("confirmar", {
        ordemBancaria: this.ordemBancaria,
        dataDoPagamento: this.dataDoPagamento,
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// ModalAutorizarPagamento.vue?2f67fc2f